<template>
  <input
    v-bind="$attrs"
    :value="displayValue"
    @input="onInput"
  >
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    value: {
      type: [Number, String], 
      required: true
    },
    increase: {
      type: Number,
      default: 0
    }
  },

  computed: {
    displayValue: {
      get() {
        const base = typeof this.value === 'number' ? this.value : 0
        return Number((base + this.increase).toFixed(2)) 
      },
      set(v) {
        const n = Number(v)
        if (!isNaN(n)) {
          this.$emit('input', n - this.increase)
        } else {
          this.$emit('input', this.value)
        }
      }
    }
  },

  methods: {
    onInput(e) {
      this.displayValue = e.target.value
    }
  }
}
</script>
